import React, { useRef, useState, useEffect } from 'react';
import { FPhi } from '@facephi/selphid-widget-web';

var CaptureMode;
(function (CaptureMode) {
    CaptureMode[CaptureMode["Front"] = 0] = "Front";
    CaptureMode[CaptureMode["Back"] = 1] = "Back";
    CaptureMode[CaptureMode["Full"] = 2] = "Full";
})(CaptureMode || (CaptureMode = {}));
var DocumentMode;
(function (DocumentMode) {
    DocumentMode[DocumentMode["SingleSide"] = 0] = "SingleSide";
    DocumentMode[DocumentMode["DoubleSide"] = 1] = "DoubleSide";
    DocumentMode[DocumentMode["Auto"] = 2] = "Auto";
})(DocumentMode || (DocumentMode = {}));
var DocumentType = {
    IDCard: 2,
    Passport: 3,
    Visa: 4,
    GreenCard: 5,
    DriversLicense: 6,
    SocialSecurityCard: 8,
    ResidentID: 7,
    HealthInsuranceCard: 9,
    TemporaryResidence: 10,
};

/* eslint-disable @typescript-eslint/no-explicit-any */
var FacePhiSelphId = function (_a) {
    var bundlePath = _a.bundlePath, className = _a.className, language = _a.language, _b = _a.cameraWidth, cameraWidth = _b === void 0 ? 1280 : _b, _c = _a.cameraHeight, cameraHeight = _c === void 0 ? 720 : _c, _d = _a.previewCapture, previewCapture = _d === void 0 ? false : _d, _e = _a.forceLandscape, forceLandscape = _e === void 0 ? false : _e, _f = _a.initialTip, initialTip = _f === void 0 ? false : _f, _g = _a.videoRecord, videoRecord = _g === void 0 ? false : _g, _h = _a.showLog, showLog = _h === void 0 ? false : _h, _j = _a.debugMode, debugMode = _j === void 0 ? false : _j, _k = _a.startSimpleMode, startSimpleMode = _k === void 0 ? false : _k, _l = _a.askSimpleMode, askSimpleMode = _l === void 0 ? false : _l, onModuleLoaded = _a.onModuleLoaded, onExtractionFinished = _a.onExtractionFinished, onExceptionCaptured = _a.onExceptionCaptured, onExtractionTimeout = _a.onExtractionTimeout, onUserCancelled = _a.onUserCancelled, onTrackStatus = _a.onTrackStatus, _m = _a.captureMode, captureMode = _m === void 0 ? CaptureMode.Full : _m, _o = _a.logImages, logImages = _o === void 0 ? true : _o, cameraId = _a.cameraId, channel = _a.channel, licenseKey = _a.licenseKey, _p = _a.cameraMirror, cameraMirror = _p === void 0 ? true : _p, timeout = _a.timeout, _q = _a.imageFormat, imageFormat = _q === void 0 ? 'image/jpeg' : _q, imageQuality = _a.imageQuality, blurredThreshold = _a.blurredThreshold, documentType = _a.documentType, country = _a.country, _r = _a.cache, cache = _r === void 0 ? false : _r, _s = _a.allowUncertain, allowUncertain = _s === void 0 ? true : _s, _t = _a.documentMode, documentMode = _t === void 0 ? DocumentMode.Auto : _t, _u = _a.canvasHD, canvasHD = _u === void 0 ? true : _u, _v = _a.allowUnknownDocuments, allowUnknownDocuments = _v === void 0 ? false : _v;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var widgetRef = useRef(null);
    var _w = useState(channel ? true : false), externalCamera = _w[0], setExternalCamera = _w[1];
    useEffect(function () {
        var node = widgetRef.current;
        if (node) {
            if (cache) {
                FPhi.SelphID.Component.generateBrowserCache(bundlePath, licenseKey);
            }
            if (channel) {
                var streamList = [
                    channel.video.getMediaStreamTrack(),
                    channel.audio.getMediaStreamTrack(),
                ];
                setExternalCamera(true);
                node.mountExternalCamera(new MediaStream(streamList));
            }
            else {
                setExternalCamera(false);
            }
            if (onModuleLoaded) {
                node.addWidgetEventListener('onModuleLoaded', onModuleLoaded);
            }
            if (onExtractionFinished) {
                node.addWidgetEventListener('onExtractionFinished', onExtractionFinished);
            }
            if (onUserCancelled) {
                node.addWidgetEventListener('onUserCancelled', onUserCancelled);
            }
            if (onExceptionCaptured) {
                node.addWidgetEventListener('onExceptionCaptured', onExceptionCaptured);
            }
            if (onExtractionTimeout) {
                node.addWidgetEventListener('onExtractionTimeout', onExtractionTimeout);
            }
            if (onTrackStatus) {
                node.addWidgetEventListener('onTrackStatus', onTrackStatus);
            }
        }
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement("facephi-selphid", { class: className, ref: widgetRef, documentAspectRatio: 85.6 / 53.98, bundlePath: bundlePath, language: language, blurredThreshold: blurredThreshold, previewCapture: previewCapture, imageFormat: imageFormat, forceLandscape: forceLandscape, initialTip: initialTip, videoRecord: videoRecord, videoRecordType: FPhi.SelphID.RecorderType.Remote, videoRecordScale: cameraWidth < 1280 ? 1 : 0.5, cameraWidth: cameraWidth, cameraHeight: cameraHeight, cameraMirror: cameraMirror, captureMode: captureMode, cameraId: cameraId, logImages: logImages, showLog: showLog, debugMode: debugMode, startSimpleMode: startSimpleMode, askSimpleMode: askSimpleMode, style: {
                width: '100%',
                height: forceLandscape ? '56.25%' : '100%',
            }, externalCamera: externalCamera, licenseKey: licenseKey, timeout: timeout, imageQuality: imageQuality, documentType: documentType ? DocumentType[documentType] : undefined, documentMode: documentMode, scanMode: country ? FPhi.SelphID.ScanMode.Search : FPhi.SelphID.ScanMode.Generic, specificData: country ? "[".concat(country, "]") : undefined, allowUncertain: country ? false : allowUncertain, allowUnknownDocuments: allowUnknownDocuments, canvasHD: canvasHD })));
};

export { CaptureMode, DocumentMode, DocumentType, FacePhiSelphId };
